/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetWeaknessInstanceDto
 */
export interface AssetWeaknessInstanceDto {
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    weaknessGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    framework?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    resolutionStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetWeaknessInstanceDto
     */
    weaknessRiskScore?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    priorityLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWeaknessInstanceDto
     */
    sourceSystem?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetWeaknessInstanceDto
     */
    lastSeenAt?: Date;
}

/**
 * Check if a given object implements the AssetWeaknessInstanceDto interface.
 */
export function instanceOfAssetWeaknessInstanceDto(value: object): value is AssetWeaknessInstanceDto {
    return true;
}

export function AssetWeaknessInstanceDtoFromJSON(json: any): AssetWeaknessInstanceDto {
    return AssetWeaknessInstanceDtoFromJSONTyped(json, false);
}

export function AssetWeaknessInstanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetWeaknessInstanceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'weaknessGoldenId': json['weaknessGoldenId'] == null ? undefined : json['weaknessGoldenId'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'framework': json['framework'] == null ? undefined : json['framework'],
        'category': json['category'] == null ? undefined : json['category'],
        'resolutionStatus': json['resolutionStatus'] == null ? undefined : json['resolutionStatus'],
        'weaknessRiskScore': json['weaknessRiskScore'] == null ? undefined : json['weaknessRiskScore'],
        'priorityLevel': json['priorityLevel'] == null ? undefined : json['priorityLevel'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
    };
}

export function AssetWeaknessInstanceDtoToJSON(json: any): AssetWeaknessInstanceDto {
    return AssetWeaknessInstanceDtoToJSONTyped(json, false);
}

export function AssetWeaknessInstanceDtoToJSONTyped(value?: AssetWeaknessInstanceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
        'weaknessGoldenId': value['weaknessGoldenId'],
        'identifier': value['identifier'],
        'framework': value['framework'],
        'category': value['category'],
        'resolutionStatus': value['resolutionStatus'],
        'weaknessRiskScore': value['weaknessRiskScore'],
        'priorityLevel': value['priorityLevel'],
        'sourceSystem': value['sourceSystem'],
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
    };
}

